import { getCoreDataSecurityAccessComparisonByObjectIdSlice } from './get';

export const {
	requestGetCoreDataSecurityAccessComparisonByObjectId,
	resetGetCoreDataSecurityAccessComparisonByObjectId
} =
    getCoreDataSecurityAccessComparisonByObjectIdSlice.asyncActionCreators;
